import React from 'react'
import { FlatList } from 'react-native-gesture-handler'
import {
  HStack,
  View,
  Box,
  Text,
  Avatar,
  Button,
  Modal,
  Input,
  Select,
  CheckIcon,
  Center,
  Stack,
  VStack,
  Tooltip,
  Image,
} from 'native-base'
import {
  DELETE_AIRCRAFT,
  UPDATE_AIRCRAFT,
  CREATE_AIRCRAFT_IMAGE,
} from '../graphql/mutations'
import { GET_FLEET } from '../graphql/queries'
import { getToken } from '../Token'
import { useMutation, useLazyQuery } from '@apollo/client'
import Loading from '../components/Loading'
import ImageUploading from 'react-images-uploading'
import { auth } from '../utils/nhost'
import { useTranslation } from 'react-i18next'
import { useForm, Controller } from 'react-hook-form'
import explanation from '../assets/question_icon.png'
import ModalError from '../components/ModalError'
import { HASURA } from '@env'

//Update and Delete Actions

export const Actions = ({ aircraft, user, onAction, onEdit }) => {
  const [updateAircraft] = useMutation(UPDATE_AIRCRAFT)
  const [show, setShow] = React.useState(false)
  const [showDelete, setShowDelete] = React.useState(false)
  const [deleteAircraft] = useMutation(DELETE_AIRCRAFT)
  const [images, setImages] = React.useState('')
  const [buttonLoading, setButtonLoading] = React.useState(false)
  const maxNumber = 1
  const [createAircraftImage] = useMutation(CREATE_AIRCRAFT_IMAGE)
  const { t } = useTranslation()
  const [getAircrafts] = useLazyQuery(GET_FLEET)
  const [error, setError] = React.useState()
  const [showError, setShowError] = React.useState(false)

  const onChange = (imageList, addUpdateIndex) => {
    setImages(imageList)
  }

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      tailNumbers: aircraft.tail_numbers,
      helicopterModel: aircraft.helicopter_makes_models,
      mtow: aircraft.mtow,
      checked: aircraft.weight_measure_type,
    },
  })

  const uploadImage = async () => {
    const token = auth.getJWTToken()
    const file = images[0].file
    const data = new FormData()
    data.append('file[]', file)
    data.append('metadata[]', file)
    try {
      let res = await fetch(`${HASURA}/v1/storage/files/`, {
        method: 'post',
        body: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      let responseJson = await res.json()
      const imageId = responseJson.processedFiles[0].id
      return imageId
    } catch (error) {
      setError(t('fleet.errors.update'))
      openError()
    }
  }

  const onSubmit = async (aircraftInformation) => {
    setButtonLoading(true)
    try {
      if (images.length > 0) {
        const imageId = await uploadImage()
        const aircraftImage = await createAircraftImage({
          variables: {
            file_id: imageId,
          },
        })

        await updateAircraft({
          variables: {
            id: aircraft.id,
            helicopter_makes_models: aircraftInformation.helicopterModel
              ? aircraftInformation.helicopterModel
              : aircraft.helicopter_makes_models,
            mtow: aircraftInformation.mtow
              ? aircraftInformation.mtow
              : aircraft.mtow,
            tail_numbers: aircraftInformation.tailNumbers
              ? aircraftInformation.tailNumbers
              : aircraft.tail_numbers,
            weight_measure_type: aircraftInformation.checked
              ? aircraftInformation.checked
              : aircraftInformation.aircraft.weight_measure_type,
            aircraft_image_id: aircraftImage.data.insert_aircraft_images_one.id,
          },
        })
        const refetchAircrafts = await getAircrafts({
          variables: { userId: user },
          fetchPolicy: 'network-only',
        })
        onEdit(refetchAircrafts.data.fleet[0].aircrafts)
        setButtonLoading(false)
        closeModalEdit()
        window.location.reload()
      } else {
        await updateAircraft({
          variables: {
            id: aircraft.id,
            helicopter_makes_models: aircraftInformation.helicopterModel
              ? aircraftInformation.helicopterModel
              : aircraft.helicopter_makes_models,
            mtow: aircraftInformation.mtow
              ? aircraftInformation.mtow
              : aircraft.mtow,
            tail_numbers: aircraftInformation.tailNumbers
              ? aircraftInformation.tailNumbers
              : aircraft.tail_numbers,
            weight_measure_type: aircraftInformation.checked
              ? aircraftInformation.checked
              : aircraft.weight_measure_type,
            aircraft_image_id: aircraft.aircraft_image_id,
          },
        })
        const refetchAircrafts = await getAircrafts({
          variables: { userId: user },
          fetchPolicy: 'network-only',
        })
        onEdit(refetchAircrafts.data.fleet[0].aircrafts)
        setButtonLoading(false)
        closeModalEdit()
      }
    } catch (error) {
      setButtonLoading(false)
      setError(t('fleet.errors.update'))
      openError()
    }
  }
  const deleteAircraftInformation = async () => {
    setButtonLoading(true)
    try {
      await deleteAircraft({
        variables: {
          id: aircraft.id,
        },
      })
      onAction(aircraft.id)
      setButtonLoading(false)
      closeModalDelete()
    } catch (error) {
      setButtonLoading(false)
      setError(t('fleet.errors.delete'))
      openError()
    }
  }

  const showEditModal = () => {
    window.scrollTo(0, 0)
    document.body.style.overflow = 'hidden'
    setShow(true)
  }

  const closeModalEdit = () => {
    document.body.style.overflow = 'scroll'
    setShow(false)
  }

  const showDeleteModal = () => {
    window.scrollTo(0, 0)
    document.body.style.overflow = 'hidden'
    setShowDelete(true)
  }

  const closeModalDelete = () => {
    document.body.style.overflow = 'scroll'
    setShowDelete(false)
  }

  const openError = () => {
    window.scrollTo(0, 0)
    document.body.style.overflow = 'hidden'
    setShowError(true)
  }

  const closeError = () => {
    document.body.style.overflow = 'scroll'
    setShowError(false)
  }

  return (
    <View>
      <HStack space={3}>
        <Button
          colorScheme="yellow"
          onPress={() => {
            showEditModal()
          }}
        >
          {t('fleet.editButton')}
        </Button>
        <Button
          colorScheme="warning"
          onPress={() => {
            showDeleteModal()
          }}
        >
          {t('fleet.deleteButton')}
        </Button>
      </HStack>

      <Modal isOpen={show} onClose={() => closeModalEdit()}>
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>{t('fleet.editAircraftTitle')}</Modal.Header>
          <Modal.Body>
            {images.length === 0 ? (
              <Center>
                <Avatar
                  bg="yellow.400"
                  size="xl"
                  source={{
                    uri: aircraft.urlImage,
                  }}
                ></Avatar>
              </Center>
            ) : (
              <Text></Text>
            )}
            <br />
            <ImageUploading
              multiple
              value={images}
              onChange={onChange}
              maxNumber={maxNumber}
              dataURLKey="data_url"
            >
              {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
                isDragging,
                dragProps,
              }) => (
                // write your building UI
                <View className="upload__image-wrapper">
                  {imageList.map((image, index) => (
                    <Center key={index}>
                      <Image
                        source={{
                          uri: `${image['data_url']}`,
                        }}
                        alt="Alternate Text"
                        size={'xl'}
                        resizeMode="cover"
                        borderRadius={100}
                      />
                      <HStack space={3} p="4">
                        <Box shadow={2} maxWidth="40">
                          <Text pt="2" isTruncated="true">
                            {image.file.name}
                          </Text>
                        </Box>
                        <Button
                          colorScheme="yellow"
                          onPress={() => onImageUpdate(index)}
                        >
                          {t('pilots.updateButton')}
                        </Button>
                        <Button
                          colorScheme="red"
                          onPress={() => onImageRemove(index)}
                        >
                          {t('pilots.removeButton')}
                        </Button>
                      </HStack>
                    </Center>
                  ))}
                  <Center>
                    <Button
                      width="40%"
                      colorScheme="yellow"
                      size="md"
                      style={isDragging ? { color: 'red' } : undefined}
                      onPress={onImageUpload}
                      {...dragProps}
                    >
                      {t('pilots.uploadImage')}
                    </Button>
                  </Center>
                </View>
              )}
            </ImageUploading>
            <Text fontSize={['xs', 'sm', 'sm', 'md']} p="2">
              {t('fleet.aircraftInformation')}
            </Text>
            <Text bold fontSize={['xs', 'sm', 'sm', 'sm']} p="2">
              {t('fleet.tailNumber')}
            </Text>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Input
                  placeholder={t('fleet.tailNumber')}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  value={value}
                  style={{ backgroundColor: 'white' }}
                  variant="unstyled"
                  borderWidth={1}
                  InputRightElement={
                    <Tooltip
                      bg="yellow.100"
                      _text={{
                        color: 'black',
                      }}
                      placement="left"
                      label="e.g., N904DE"
                    >
                      <Image
                        source={{
                          uri: explanation,
                        }}
                        alt="Alternate Text"
                        mr={2}
                        style={{ width: 20, height: 20 }}
                      />
                    </Tooltip>
                  }
                />
              )}
              name="tailNumbers"
            />
            {errors.tailNumbers && (
              <Text p="2" fontSize="xs" color="#eb0100">
                {t('fleet.required')}
              </Text>
            )}

            <Text bold fontSize="s" p="2">
              {t('fleet.model')}
            </Text>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Input
                  placeholder={t('fleet.model')}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  value={value}
                  style={{ backgroundColor: 'white' }}
                  variant="unstyled"
                  borderWidth={1}
                  InputRightElement={
                    <Tooltip
                      bg="yellow.100"
                      _text={{
                        color: 'black',
                      }}
                      placement="left"
                      label="e.g., Bell 206"
                    >
                      <Image
                        source={{
                          uri: explanation,
                        }}
                        alt="Alternate Text"
                        mr={2}
                        style={{ width: 20, height: 20 }}
                      />
                    </Tooltip>
                  }
                />
              )}
              name="helicopterModel"
            />
            {errors.helicopterModel && (
              <Text p="2" fontSize="xs" color="#eb0100">
                {t('fleet.required')}
              </Text>
            )}

            <Text bold fontSize="s" p="2">
              {t('fleet.maxWeight')}
            </Text>
            <HStack space={3}>
              <VStack space={1}>
                <Controller
                  control={control}
                  rules={{
                    required: true,
                    pattern: {
                      value: /^[1-9]\d*(\.\d+)?$/,
                      message: t('fleet.ruleNumber'),
                    },
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Input
                      placeholder={t('fleet.maxWeight')}
                      onBlur={onBlur}
                      onChangeText={onChange}
                      value={value}
                      style={{ backgroundColor: 'white' }}
                      variant="unstyled"
                      borderWidth={1}
                      InputRightElement={
                        <Tooltip
                          bg="yellow.100"
                          _text={{
                            color: 'black',
                          }}
                          placement="left"
                          label="e.g., 500"
                        >
                          <Image
                            source={{
                              uri: explanation,
                            }}
                            alt="Alternate Text"
                            mr={2}
                            style={{ width: 20, height: 20 }}
                          />
                        </Tooltip>
                      }
                    />
                  )}
                  name="mtow"
                />
                {errors.mtow && (
                  <Text p="2" fontSize="xs" color="#eb0100">
                    {errors.mtow.message
                      ? errors.mtow.message
                      : t('fleet.required')}
                  </Text>
                )}
              </VStack>
              <VStack space={1}>
                <Controller
                  control={control}
                  rules={{
                    required: true,
                  }}
                  render={({ field: { onChange, onBlur, value } }) => (
                    <Select
                      onBlur={onBlur}
                      selectedValue={value}
                      minWidth="200"
                      accessibilityLabel="Choose Service"
                      placeholder="kg/lbs"
                      _selectedItem={{
                        bg: 'teal.600',
                        endIcon: <CheckIcon size="5" />,
                      }}
                      onValueChange={onChange}
                    >
                      <Select.Item label="kg" value="kg" />
                      <Select.Item label="lbs" value="lbs" />
                      <Select.Item label="t" value="t" />
                    </Select>
                  )}
                  name="checked"
                />
                {errors.checked && (
                  <Text p="2" fontSize="xs" color="#eb0100">
                    {t('fleet.required')}
                  </Text>
                )}
              </VStack>
            </HStack>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                variant="ghost"
                colorScheme="blueGray"
                onPress={() => {
                  closeModalEdit()
                }}
              >
                {t('fleet.cancelButton')}
              </Button>
              <Button
                colorScheme="yellow"
                isLoading={buttonLoading}
                _loading={{
                  bg: 'amber.400:alpha.70',
                  _text: {
                    color: 'coolGray.700',
                  },
                }}
                _spinner={{
                  color: 'white',
                }}
                isLoadingText={t('submit_button.text')}
                onPress={handleSubmit(onSubmit)}
              >
                {t('fleet.saveButton')}
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
      <Modal isOpen={showDelete} onClose={() => closeModalDelete()}>
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>{t('fleet.deleteFleet')}</Modal.Header>
          <Modal.Body>
            <Text fontSize={['xs', 'sm', 'sm', 'md']} p="2">
              {t('fleet.confirmMessage')}
            </Text>
          </Modal.Body>
          <Modal.Footer>
            <Button.Group space={2}>
              <Button
                colorScheme="yellow"
                isLoading={buttonLoading}
                _loading={{
                  bg: 'amber.400:alpha.70',
                  _text: {
                    color: 'coolGray.700',
                  },
                }}
                _spinner={{
                  color: 'white',
                }}
                isLoadingText={t('submit_button.text')}
                onPress={() => {
                  deleteAircraftInformation()
                }}
              >
                {t('fleet.confirmButton')}
              </Button>
              <Button
                colorScheme="danger"
                onPress={() => {
                  closeModalDelete()
                }}
              >
                {t('fleet.neverMindButton')}
              </Button>
            </Button.Group>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
      <Modal isOpen={showError}>
        <ModalError error={error} onClose={closeError} />
      </Modal>
    </View>
  )
}

//AircraftList

export const AircraftList = ({ aircrafts, onAction, onEdit }) => {
  const [loading, setLoading] = React.useState(true)
  const [user, setUser] = React.useState('')
  const { t } = useTranslation()

  const handleActionImage = () => {
    setShow(false)
  }

  React.useEffect(() => {
    const tokenInformation = getToken()
    const userId =
      tokenInformation['https://hasura.io/jwt/claims']['x-hasura-user-id']
    setUser(userId)
    setLoading(false)
  }, [])

  if (loading) return <Loading />
  return (
    <View>
      <FlatList
        data={aircrafts}
        keyExtractor={(item) => item.id.toString()}
        ItemSeparatorComponent={() => <br />}
        renderItem={({ item }) => (
          <Box
            p={[4, 4, 9, 9]}
            rounded="xl"
            bgColor="white"
            key={item.id.toString()}
          >
            <Stack space={3} direction={['column', 'column', 'column', 'row']}>
              <View width={['100%', '100%', '100%', '50%']}>
                <Text fontSize={['xs', 'sm', 'sm', 'md']} fontWeight="bold">
                  {item.name}
                </Text>
                <VStack space={3}>
                  <HStack space={1}>
                    <Text fontSize={['xs', 'sm', 'sm', 'md']} bold>
                      {t('fleet.model')}:
                    </Text>
                    <Text fontSize={['xs', 'sm', 'sm', 'md']}>
                      {item.helicopter_makes_models}
                    </Text>
                  </HStack>
                  <HStack space={1}>
                    <Text fontSize={['xs', 'sm', 'sm', 'md']} bold>
                      {t('fleet.tailNumber')}:
                    </Text>
                    <Text fontSize={['xs', 'sm', 'sm', 'md']}>
                      {item.tail_numbers}
                    </Text>
                  </HStack>
                  <HStack space={1}>
                    <Text fontSize={['xs', 'sm', 'sm', 'md']} bold>
                      {t('fleet.maxWeight')}:
                    </Text>
                    <Text fontSize={['xs', 'sm', 'sm', 'md']}>
                      {item.mtow.toString()} {item.weight_measure_type}
                    </Text>
                  </HStack>
                </VStack>
              </View>
              <View width="20%" pl={['30%', '30%', '40%', '0%']}>
                <Avatar
                  bg="yellow.400"
                  size="xl"
                  source={{
                    uri: item.urlImage
                      ? item.urlImage
                      : `https://cdn.pixabay.com/photo/2017/03/04/14/19/helicopter-2116170_1280.jpg`,
                  }}
                ></Avatar>
              </View>
              <View pt="2%" pl={['25%', '25%', '37%', '0%']}>
                <Actions
                  aircraft={item}
                  user={user}
                  onAction={onAction}
                  onEdit={onEdit}
                />
              </View>
            </Stack>
          </Box>
        )}
      />
    </View>
  )
}
export default AircraftList
